import { render, staticRenderFns } from "./MultipleChoice.vue?vue&type=template&id=734bdc37"
import script from "./MultipleChoice.vue?vue&type=script&lang=ts"
export * from "./MultipleChoice.vue?vue&type=script&lang=ts"
import style0 from "./MultipleChoice.vue?vue&type=style&index=0&id=734bdc37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports